import React from 'react';
import { Link } from 'react-router-dom';
import { MapIcon, RouteIcon, MountainIcon, LanguagesIcon, LayoutDashboardIcon, SmartphoneIcon, ArrowRightIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
export function TripppMapPage() {
  const {
    t
  } = useTranslation();
  return <div className="pt-24" data-id="element-529">
      <section className="relative py-24 lg:py-32 overflow-hidden" data-id="element-530">
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-531">
          <div className="aurora-blob bg-[#FF6B00] w-[600px] h-[600px] top-[-10%] right-[-10%] animate-aurora-1" data-id="element-532"></div>
          <div className="aurora-blob bg-[#2563EB] w-[800px] h-[800px] bottom-[-20%] left-[-10%] animate-aurora-2" data-id="element-533"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-534">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-535">
            <div data-id="element-536">
              <div className="inline-block px-4 py-1.5 rounded-full border border-white/10 bg-white/5 mb-6" data-id="element-537">
                <span className="text-sm font-bold text-gradient uppercase tracking-wider" data-id="element-538">
                  {t('tripppMap.badge')}
                </span>
              </div>
              <h1 className="text-5xl lg:text-7xl font-bold leading-[1.1] mb-6" data-id="element-539">
                {t('tripppMap.heroTitle')}
                <span className="text-gradient" data-id="element-540">
                  {t('tripppMap.heroTitleHighlight')}
                </span>
              </h1>
              <p className="text-xl text-white/60 mb-10 leading-relaxed" data-id="element-541">
                {t('tripppMap.heroDesc')}
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-542">
                <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="bg-gradient-animated rounded-full px-8 py-4 text-base font-semibold text-white text-center hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(255,107,0,0.3)]" data-id="element-543">
                  {t('tripppMap.bookDemo')}
                </a>
                <a href="https://map.visitbenimellal.com" target="_blank" rel="noopener noreferrer" className="rounded-full border border-white/20 px-8 py-4 text-base font-semibold text-white text-center hover:border-transparent hover:bg-white/5 transition-all duration-300 relative group overflow-hidden inline-block" data-id="element-544">
                  <div className="absolute inset-0 bg-gradient-animated opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
                  padding: '1px',
                  WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                  WebkitMaskComposite: 'xor',
                  maskComposite: 'exclude'
                }} data-id="element-545"></div>
                  <span className="relative z-10" data-id="element-546">
                    {t('tripppMap.seeItLive')}
                  </span>
                </a>
              </div>
            </div>
            <div className="relative h-[500px] rounded-3xl border border-white/10 bg-[#0A0A0A] overflow-hidden shadow-2xl" data-id="element-547">
              <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:40px_40px]" data-id="element-548"></div>
              <div className="absolute top-[30%] left-[40%] w-4 h-4 rounded-full bg-[#FF6B00] shadow-[0_0_20px_#FF6B00] animate-pulse" data-id="element-549"></div>
              <div className="absolute top-[45%] left-[60%] w-4 h-4 rounded-full bg-[#FF3CAC] shadow-[0_0_20px_#FF3CAC] animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-550"></div>
              <div className="absolute top-[60%] left-[30%] w-4 h-4 rounded-full bg-[#00E5FF] shadow-[0_0_20px_#00E5FF] animate-pulse" style={{
              animationDelay: '2s'
            }} data-id="element-551"></div>
              <div className="absolute bottom-6 left-6 right-6 h-24 rounded-xl bg-white/5 border border-white/10 backdrop-blur-md p-4 flex items-center gap-4" data-id="element-552">
                <div className="w-16 h-16 rounded-lg bg-white/10" data-id="element-553"></div>
                <div className="flex-1" data-id="element-554">
                  <div className="h-4 w-1/2 bg-white/20 rounded mb-2" data-id="element-555"></div>
                  <div className="h-3 w-3/4 bg-white/10 rounded" data-id="element-556"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-557">
        <div className="max-w-7xl mx-auto px-6" data-id="element-558">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-559">
            {t('tripppMap.featuresTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-560">
            {[{
            icon: <MapIcon className="w-6 h-6 text-white" data-id="element-561" />,
            titleKey: 'tripppMap.feature0Title',
            descKey: 'tripppMap.feature0Desc'
          }, {
            icon: <RouteIcon className="w-6 h-6 text-white" data-id="element-562" />,
            titleKey: 'tripppMap.feature1Title',
            descKey: 'tripppMap.feature1Desc'
          }, {
            icon: <MountainIcon className="w-6 h-6 text-white" data-id="element-563" />,
            titleKey: 'tripppMap.feature2Title',
            descKey: 'tripppMap.feature2Desc'
          }, {
            icon: <LanguagesIcon className="w-6 h-6 text-white" data-id="element-564" />,
            titleKey: 'tripppMap.feature3Title',
            descKey: 'tripppMap.feature3Desc'
          }, {
            icon: <LayoutDashboardIcon className="w-6 h-6 text-white" data-id="element-565" />,
            titleKey: 'tripppMap.feature4Title',
            descKey: 'tripppMap.feature4Desc'
          }, {
            icon: <SmartphoneIcon className="w-6 h-6 text-white" data-id="element-566" />,
            titleKey: 'tripppMap.feature5Title',
            descKey: 'tripppMap.feature5Desc'
          }].map((feature, idx) => <div key={idx} className="bg-[#0A0A0A] border border-white/10 rounded-2xl p-8 hover:border-white/20 transition-colors" data-id="element-567">
                <div className="w-12 h-12 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center mb-6 relative overflow-hidden" data-id="element-568">
                  <div className="absolute inset-0 bg-gradient-animated opacity-20" data-id="element-569"></div>
                  <div className="relative z-10" data-id="element-570">{feature.icon}</div>
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-571">
                  {t(feature.titleKey)}
                </h3>
                <p className="text-white/60 leading-relaxed" data-id="element-572">
                  {t(feature.descKey)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-573">
        <div className="max-w-7xl mx-auto px-6" data-id="element-574">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-575">
            {t('tripppMap.targetsTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-576">
            {[0, 1, 2, 3].map(idx => <div key={idx} className="bg-[#050505] border border-white/10 rounded-2xl p-8" data-id="element-577">
                <h3 className="text-lg font-bold mb-3 text-gradient" data-id="element-578">
                  {t(`tripppMap.target${idx}Title`)}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed" data-id="element-579">
                  {t(`tripppMap.target${idx}Desc`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-580">
        <div className="max-w-7xl mx-auto px-6" data-id="element-581">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-582">
            {t('tripppMap.deploymentsTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-583">
            {[0, 1].map(idx => <div key={idx} className="group relative rounded-3xl overflow-hidden bg-[#0A0A0A] min-h-[300px]" data-id="element-584">
                <div className="absolute inset-0 border border-white/10 rounded-3xl group-hover:opacity-0 transition-opacity duration-300" data-id="element-585"></div>
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 border-gradient-animated rounded-3xl" data-id="element-586"></div>
                <div className="relative h-full p-10 flex flex-col justify-end z-10" data-id="element-587">
                  <h3 className="text-3xl font-bold mb-4 text-white" data-id="element-588">
                    {t(`tripppMap.deployment${idx}Title`)}
                  </h3>
                  <p className="text-white/60 text-lg leading-relaxed mb-8" data-id="element-589">
                    {t(`tripppMap.deployment${idx}Desc`)}
                  </p>
                  <button type="button" className="inline-flex items-center text-sm font-semibold text-gradient group-hover:tracking-wide transition-all duration-300" data-id="element-590">
                    {t('tripppMap.exploreTheMap')}{' '}
                    <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-591" />
                  </button>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-592">
        <div className="max-w-4xl mx-auto px-6" data-id="element-593">
          <h2 className="text-3xl md:text-5xl font-bold mb-12 text-center" data-id="element-594">
            {t('tripppMap.techTitle')}
          </h2>
          <ul className="space-y-6" data-id="element-595">
            {[0, 1, 2, 3, 4, 5].map(idx => <li key={idx} className="flex items-start text-lg text-white/80" data-id="element-596">
                <div className="w-2 h-2 rounded-full bg-gradient-animated mr-6 mt-2.5 shrink-0" data-id="element-597"></div>
                {t(`tripppMap.tech${idx}`)}
              </li>)}
          </ul>
        </div>
      </section>

      <section className="relative py-32 overflow-hidden bg-[#050505] border-t border-white/5" data-id="element-598">
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-599">
          <div className="aurora-blob bg-[#CC00FF] w-[400px] h-[400px] top-[10%] left-[20%] animate-aurora-2" data-id="element-600"></div>
          <div className="aurora-blob bg-[#2563EB] w-[500px] h-[500px] bottom-[10%] right-[20%] animate-aurora-1" style={{
          animationDirection: 'reverse'
        }} data-id="element-601"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-602">
          <h2 className="text-4xl md:text-6xl font-bold mb-12" data-id="element-603">
            {t('tripppMap.ctaTitle')}
            <span className="text-gradient" data-id="element-604">{t('tripppMap.ctaHighlight')}</span>
          </h2>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_40px_rgba(0,229,255,0.3)]" data-id="element-605">
            {t('tripppMap.ctaCta')}
          </a>
        </div>
      </section>
    </div>;
}